
import RouteConst from 'modules/routes'
import { Rules } from './permissions'

const menus = [
  {
    title : "App",
    permission: Rules.menu.app
  },
  {
    title:      "Dashboard",
    to:         RouteConst.dashboard.index,
    icon:       "dripicons-home",
    permission: Rules.menu.dashboard
  },
    // ------- Inventory -------
    {
      title : "INVENTORY",
      permission: Rules.menu.inventory
    },
       {
          title:      "Products",
          to:         RouteConst.inventory.products,
          icon:       "dripicons-view-list-large",
          permission: Rules.menu.inventory
       },
      {
        title:      "Categories",
        to:         RouteConst.inventory.categories,
        icon:       "dripicons-folder",
        permission: Rules.menu.inventory
      },
      {
        title:      "Types",
        to:         RouteConst.inventory.types,
        icon:       "dripicons-tags",
        permission: Rules.menu.inventory
      },
    // ------- Reports -------
    {
      title : "REPORTS",
      permission: Rules.menu.reports
    },
    {
      title:      "Reports",
      to:         RouteConst.reports.reports.index,
      icon:       "dripicons-clipboard",
      permission: Rules.menu.reports
    },
    // ------- Settings -------
    {
        title : "SETTINGS",
        permission: Rules.menu.settings
    },
    {
        title:      "Users",
        to:         RouteConst.accounts.index,
        icon:       "dripicons-user-group",
        permission: Rules.menu.account
    },
    {
        title:      "Companies",
        to:         RouteConst.companies.index,
        icon:       "dripicons-briefcase",
        permission: Rules.menu.company
    },
  {
    title:      "Employees",
    to:         RouteConst.employees.index,
    icon:       "dripicons-user-id",
    permission: Rules.menu.employee
  },
      // {
      //   title:      "Companies",
      //   to:         RouteConst.company.company.index,
      //   icon:       "uil-building",
      //   permission: Rules.menu.company
      // },
]

export default menus
